/* Saved-vehicle badges shared by normal collections and vehicle finder cards. */
(function () {
  'use strict';
  const core = window.JSDieselFitment;
  const vehicle = window.JSSVehicle;
  if (!core || !vehicle || customElements.get('jss-card-fitment')) return;
  class CardFitment extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.label = this.querySelector('[data-card-fitment-label]');
      if (!this.label) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      window.addEventListener('jss:vehicle-change', () => this.refresh(), options);
      this.addEventListener('jss:card-fitment-update', () => this.readData(), options);
      this.readData();
    }
    readData() {
      this.hidden = true;
      this.data = null;
      try { this.data = JSON.parse(this.querySelector('[data-card-fitment-json]').textContent); }
      catch (_) { return; }
      const variants = this.data?.variants;
      // Truncated or malformed records must never produce a positive badge.
      if (!this.label || !Array.isArray(variants) || !variants.length || this.data.variantCount !== variants.length ||
          new Set(variants.map(v => v.id)).size !== variants.length || variants.some(v => !/^\d+$/.test(v.id) || !Array.isArray(v.applications) || v.applicationCount !== v.applications.length)) {
        this.data = null;
        return;
      }
      this.refresh();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
    show(state, text, detail) {
      this.dataset.state = state;
      this.label.textContent = text;
      this.label.title = detail;
      this.label.setAttribute('aria-label', text + '. ' + detail);
      this.hidden = false;
    }
    refresh() {
      this.hidden = true;
      this.dataset.state = 'unknown';
      this.label.textContent = '';
      if (!this.data) return;
      const variants = this.data.variants;
      if (variants.every(v => v.fitmentClass === 'universal')) {
        this.show('universal', 'Universal parts', 'Check product dimensions and installation requirements.');
        return;
      }
      const saved = vehicle.get();
      if (!saved || !core.vehicleKeys.every(k => saved.values[k] && saved.confirmedKeys.includes(k))) return;
      const name = ['make', 'year', 'model', 'engine', 'type', 'body'].map(k => saved.values[k]).filter(Boolean).join(' ');
      const checks = variants.map(v => ({
        variant: v,
        result: !v.fitmentClass || v.fitmentClass === 'vehicle' ? core.checkVehicle(v.applications, saved.values) : { status: 'unknown' }
      }));
      // Fitment notes do not erase a verified vehicle match. The product page
      // and finder details still show the installation requirements.
      const matches = checks.filter(check => ['match', 'restricted'].includes(check.result.status));
      const note = matches.some(check => check.result.status === 'restricted') ? ' Check fitment notes on the product page.' : '';
      if (matches.length === variants.length) {
        this.show('match', 'Fits your vehicle', 'Verified application for ' + name + '.' + note);
      } else if (matches.length) {
        const titles = matches.map(check => check.variant.title).filter(title => title && title !== 'Default Title').join('; ');
        this.show('options', 'Matching option available', 'For ' + name + '. Choose a matching product option' + (titles ? ': ' + titles : '') + '.' + note);
      }
    }
  }
  customElements.define('jss-card-fitment', CardFitment);
})();
